import './styles.css';

import {
  AbsoluteCenter,
  Box,
  chakra,
  Flex,
  Image,
  shouldForwardProp,
  Text
} from '@chakra-ui/react';
import { isValidMotionProp, motion } from 'framer-motion';
import i18next from 'i18next';
import { useMemo } from 'react';
import { useTranslation } from 'react-i18next';
import { Link, useSearchParams } from 'react-router-dom';

import { COMMON_WEB_PATH } from '../../constant';
import { formatNumber } from '../../utils/formatNumber';
import { map } from 'lodash';

const ChakraBox = chakra(motion.div, {
  shouldForwardProp: (prop) =>
    isValidMotionProp(prop) || shouldForwardProp(prop)
});

const BetRecordDetail = ({
  fontStyle,
  setOpenBetRecordDetail,
  betRecordDetail,
  gameOptions
} = {}) => {
  const { t } = useTranslation();
  const i18n = (key) => t(`common.${key}`);

  const [searchParams, setSearchParams] = useSearchParams();

  const game = searchParams.get('game') || '';

  const numberColor = useMemo(() => {
    const NUMBER = betRecordDetail?.totalWinOrLose || 0;
    if (typeof NUMBER === 'string') {
      NUMBER = Number(NUMBER);
    }

    if (NUMBER > 0) {
      return 'green.500';
    } else if (NUMBER < 0) {
      return 'red.500';
    } else {
      return 'white';
    }
  }, [betRecordDetail?.totalWinOrLose]);

  const getFilteredRecords = useMemo(() => {
    return (
      betRecordDetail[game] || {
        totalBet: 0,
        totalWinOrLose: 0
      }
    );
  }, [game, betRecordDetail]);

  return (
    <>
      <ChakraBox
        as={Flex}
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 0.3, delay: 0.3 }}
        w="650px"
        h="500px"
        bgImage={`url('${COMMON_WEB_PATH}/blue-layout/bet-record/bet_record_background.png')`}
        bgPosition="center"
        bgRepeat="no-repeat"
        bgSize="100% 100%"
        display="flex"
        flexDirection="column"
        alignItems="center"
        justifyContent="flex-start"
        position={'relative'}
        pb="20px"
        px="30px"
      >
        {gameOptions?.length > 0 && (
          <Box
            position="absolute"
            w="150px"
            h="100%"
            top="0"
            left="-100px"
            display="flex"
            flexDirection="column"
            alignItems={'center'}
            gap="10px"
            overflow="scroll"
            zIndex={-1}
          >
            {map(gameOptions, (opt) => (
              <Box
                as={Link}
                to={{
                  search: `?game=${opt}`
                }}
                onClick={() => {
                  setOpenBetRecordDetail(true);
                }}
                py="10px"
                bgImage={`url(${COMMON_WEB_PATH}/blue-layout/bet-record/bet_record_background.png)`}
                bgSize="100% 100%"
                bgPos="center"
                w="100%"
                minH="80px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                textAlign="center"
                cursor="pointer"
              >
                <Text fontWeight={900} fontSize="1.5em">
                  {opt}
                </Text>
              </Box>
            ))}
          </Box>
        )}
        <Box
          zIndex={1}
          position="absolute"
          bgImage={`url('${COMMON_WEB_PATH}/blue-layout/bet-record/bet_record_close.png')`}
          bgSize="100% 100%"
          bgPos="center"
          w="120px"
          h="120px"
          top="0px"
          right="-50px"
          cursor="pointer"
          onClick={() => {
            setOpenBetRecordDetail(false);
          }}
        ></Box>
        <Box
          display="flex"
          flexDirection={'column'}
          alignItems={'center'}
          justifyContent={'center'}
          w="100%"
          h="100%"
          flex={1}
          py="80px"
        >
          <Box
            flex={0.7}
            pb="50px"
            pt="10px"
            bgImage={`url('${COMMON_WEB_PATH}/blue-layout/bet-record/bet-record-inner.png')`}
            bgPosition="center"
            bgRepeat="no-repeat"
            bgSize="100% 100%"
            display="flex"
            flexDirection={'column'}
            alignItems={'center'}
            justifyContent={'center'}
            w="50%"
          >
            <Box display={'flex'} alignItems={'center'}>
              {/* 標題 */}
              <Text fontSize="37px" fontWeight={900}>
                {game || i18n('請選擇')}
              </Text>
            </Box>

            <Box
              flex={1}
              display={'flex'}
              flexDir={'column'}
              gap="15px"
              alignItems={'center'}
              justifyContent={'center'}
              w="100%"
            >
              <Box
                position="relative"
                w="80%"
                h="40px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgSize="100% 100%"
                bgPos="center"
                bgRepeat={'no-repeat'}
                bgImage={`url(${COMMON_WEB_PATH}/blue-layout/bet-record/log_background.png)`}
              >
                <AbsoluteCenter top="-5px">
                  <Text color="#B6E9F9" fontSize="15px" fontWeight={700}>
                    投注
                  </Text>
                </AbsoluteCenter>
                <Text>{formatNumber(getFilteredRecords?.totalBet || 0)}</Text>
              </Box>

              <Box
                position="relative"
                w="80%"
                h="40px"
                display="flex"
                alignItems="center"
                justifyContent="center"
                bgSize="100% 100%"
                bgPos="center"
                bgRepeat={'no-repeat'}
                bgImage={`url(${COMMON_WEB_PATH}/blue-layout/bet-record/log_background.png)`}
              >
                <AbsoluteCenter top="-5px">
                  <Text color="#B6E9F9" fontSize="15px" fontWeight={700}>
                    輸贏
                  </Text>
                </AbsoluteCenter>
                <Text>
                  {formatNumber(getFilteredRecords?.totalWinOrLose || 0)}
                </Text>
              </Box>
            </Box>
          </Box>
        </Box>
      </ChakraBox>{' '}
    </>
  );
};

export default BetRecordDetail;
